import { useParams } from 'react-router'

export const useCustomerId = () => {
  const { id: customerId } = useParams()
  return customerId
}
